import { logAndToast } from './logAndToast';
import { type LogHelper, LogLevels } from '@types';
import { writeIntoLogs } from '@lib/logger/writeIntoLogs.ts';

export const logWarning: LogHelper = async (
  message,
  source,
  context,
  showToast = true,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'warning',
    forceLog
  });
};

export async function writeWarningLog<T> (message: string, source: string, context: Record<string, T>): Promise<void> {
  await writeIntoLogs({
    message,
    level: LogLevels.WARNING,
    source,
    context 
  });
}